export const LAST_ACTION_DATE = 'marketing-tips-last-action-date';
export const ACTION_COUNT = 'marketing-tips-action-count';

export const INSIGHT_ACTION_PREFIX = 'marketing-tips-';

export const PARTY_EMOJI_ID = 0x1F389;
export const DEFAULT_NUMBER_OF_CARDS_SHOWN = 2;
export const NUMBER_OF_CARDS_SHOWN = 2;

export const MARKETING_TIPS_ACTIONS = Object.freeze({
  standard: 1,
  dismiss: 2,
  cta: 3,
  addCelebration: 4,
  removeCelebration: 5,
});

export const INSIGHT_ACTIONS = Object.freeze({
  CTA_CLICKED: 1,
  DISMISS_CLICKED: 2,
});

export const INSIGHT_TYPES = Object.freeze({
  AddPhotos: 'addPhotos',
  LastMinuteAvailability: 'lastMinuteAvailability',
  InviteClientsToBook: 'inviteClientsToBook',
  AddStyleSeatToInstagram: 'addStyleSeatToInstagram',
  RequestReviews: 1,
  BookOnInstagram: 2,
  ShareProfile: 3,
  PromoteProfile: 4,
  AdsRan: 5,
  ElevatePhotos: 6,
  PhotoUpdates: 7,
  TagPhoto: 8,
  ShareInstagram: 9,
  AddSpeciality: 10,
  PositiveReviewAsset: 11,
});

export const INSIGHT_DISPLAY_ORDER = Object.freeze({
  [INSIGHT_TYPES.AddStyleSeatToInstagram]: 0,
  [INSIGHT_TYPES.InviteClientsToBook]: 1,
  [INSIGHT_TYPES.AddSpeciality]: 2,
  [INSIGHT_TYPES.LastMinuteAvailability]: 3,
  [INSIGHT_TYPES.PositiveReviewAsset]: 4,
  [INSIGHT_TYPES.BookOnInstagram]: 5,
  [INSIGHT_TYPES.AddPhotos]: 6,
  [INSIGHT_TYPES.RequestReviews]: 7,
  [INSIGHT_TYPES.PromoteProfile]: 8,
  [INSIGHT_TYPES.ShareProfile]: 9,
  [INSIGHT_TYPES.ElevatePhotos]: 10,
  [INSIGHT_TYPES.AdsRan]: 11,
  [INSIGHT_TYPES.PhotoUpdates]: 12,
  [INSIGHT_TYPES.TagPhoto]: 13,
  [INSIGHT_TYPES.ShareInstagram]: 14,
});
